<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14.5 14.5" :class="[`${prefix}-icon`, `${prefix}-icon-add2`]" width="1em" height="1em" v-bind="$attrs"><defs><linearGradient x1="0" y1="0" x2="1" y2="1" id="svg_33486c2a5e__a"><stop offset="0%" stop-color="#D334F7"/><stop offset="100%" stop-color="#7C34F7"/></linearGradient></defs><path d="M11.2166,0C13.0301,0.000334743,14.5,1.47001,14.5,3.28284L14.5,11.2166C14.5007,13.0302,13.0302,14.5007,11.2166,14.5L3.28284,14.5C1.4694,14.5003,-0.000670702,13.03,0,11.2166L0,3.28284C0.000670355,1.46958,1.47025,0,3.28284,1.73802e-7L11.2166,0ZM6.96296,2.51194C6.77266,2.62501,6.65957,2.83323,6.66834,3.05442L6.66834,6.67623L3.05503,6.67623C2.71455,6.66543,2.43268,6.93851,2.43268,7.27916C2.43268,7.61981,2.71455,7.89288,3.05503,7.88208L6.66955,7.88208L6.66955,11.4978C6.66955,11.831,6.93963,12.101,7.27278,12.101C7.60594,12.101,7.87601,11.831,7.87601,11.4978L7.87601,7.88026L11.4984,7.88026C11.8415,7.89568,12.1281,7.62168,12.1281,7.27825C12.1281,6.93481,11.8415,6.66081,11.4984,6.67623L7.87419,6.67623L7.87419,3.05442C7.88302,2.83335,7.77013,2.62518,7.58002,2.512C7.38991,2.39882,7.1531,2.3988,6.96296,2.51194Z" :fill="useCurrentColor ? 'currentColor' : 'url(#svg_33486c2a5e__a)'"/></svg>
</template>
<script>

export default {
  name: 'IconAdd2',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
